<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 168 150"
    style="enable-background: new 0 0 168 150"
    xml:space="preserve"
  >
    <g></g>
    <g></g>
    <g class="st0"></g>
    <g>
      <g>
        <g>
          <g class="st3">
            <path
              class="st5"
              d="M48.586,137.18c-0.28,3.079-0.56,4.279-1.279,6.119c-1.24,2.959-2.8,4.959-5.72,7.159
                    c-0.92-1.399-1.359-1.879-2.239-2.56c-0.8-0.04-1.28-0.04-2.16-0.04h-7.639v2H25.43c0.16-1.2,0.24-2.28,0.24-4.199v-7.919
                    c0-1.08,0-1.52,0.04-3.239c-1.12,1.28-1.32,1.52-2.399,2.399c-0.521-1.399-0.96-2.319-1.8-3.52
                    c2.839-2.12,4.919-4.439,6.639-7.358h-2.08c-1.56,0-2.52,0.08-3.399,0.2v-3.799c0.92,0.16,1.68,0.2,2.92,0.2h0.32
                    c-0.641-0.6-1.92-1.32-3.279-1.84c2.359-2.56,3.599-4.719,4.479-7.639l3.92,0.88c-0.44,1-0.561,1.24-1.08,2.28h6.639
                    c1.88,0,2.88-0.04,3.88-0.24v3.839c-1.08-0.12-2-0.16-3.68-0.16h-2c-0.399,1.32-0.52,1.76-0.92,2.88h4.08
                    c1.439,0,2.239-0.04,3.079-0.2v3.759c-0.96-0.12-1.88-0.16-3.159-0.16h-5.479c-0.6,1.2-0.92,1.76-1.92,3.239h2.72
                    c0.68-1.12,0.96-1.68,1.399-2.879l3.479,0.88c-0.439,0.72-0.439,0.76-1.239,2h1.12c1.56,0,2.199-0.04,2.919-0.16v3.479
                    c-0.88-0.08-1.76-0.12-2.959-0.12h-1.561v2.04h1.12c1.64,0,2.2-0.04,2.84-0.12v3.12c-0.72-0.08-1.68-0.12-2.84-0.12h-1.12v2.04
                    h1.08c1.64,0,2.2-0.04,2.84-0.12v3.159c-0.72-0.08-1.28-0.12-2.84-0.12h-1.08v2.279h1.16c1.96,0,2.399-0.04,3.079-0.12v1.28
                    c2.521-2.16,3.88-4.959,4.16-8.598h-0.44c-0.96,0-1.68,0.04-2.439,0.12c0.12-1.12,0.16-1.919,0.16-4.159v-14.797
                    c0-2-0.04-2.8-0.2-3.959c1.12,0.16,2.159,0.2,3.919,0.2h8.359c1.839,0,2.839-0.04,3.879-0.2c-0.12,1.24-0.16,2.399-0.16,4.399
                    v14.357c0,2.08,0.04,3.08,0.16,4.239c-1.16-0.16-1.96-0.2-3.68-0.2h-0.399v7.679c0,0.56,0.24,0.72,1.199,0.72
                    c1.04,0,1.36-0.12,1.521-0.56c0.159-0.44,0.279-2.24,0.319-5.119c1.24,0.8,2.399,1.32,3.52,1.6
                    c-0.319,7.239-0.88,8.079-5.759,8.079c-3.84,0-4.68-0.52-4.68-2.96v-9.438H48.586z M29.789,122.623
                    c0.44-1.16,0.64-1.72,0.96-2.88h-2.64c-0.64,1.12-1.04,1.68-1.96,2.88H29.789z M32.87,134.501v-2.04H29.43v2.04H32.87z
                     M29.43,139.42h3.439v-2.04H29.43V139.42z M29.43,144.619h3.439v-2.279H29.43V144.619z M45.987,121.023h7.839v-2.959h-7.839
                    V121.023z M45.987,127.182h7.839v-2.919h-7.839V127.182z M45.987,133.661h7.839v-3.24h-7.839V133.661z"
            />
            <path
              class="st5"
              d="M67.031,123.463c2.64,1.64,4.199,2.839,6.278,4.879l-2.68,3.479c-2.119-2.319-3.679-3.639-6.278-5.279
                    L67.031,123.463z M73.389,137.14c-1.279,4.519-2.159,6.839-4.079,10.838c-0.36,0.8-0.439,0.96-0.88,1.92l-3.76-3.12
                    c2-2.56,3.52-6.039,5.239-12.078L73.389,137.14z M68.31,113.544c2.76,1.88,4.119,3.08,5.879,5.119l-2.919,3.2
                    c-1.88-2.24-3.319-3.52-5.879-5.359L68.31,113.544z M80.468,142.659c-1.6,3.239-2.84,4.919-5.439,7.479
                    c-1.279-1.479-1.879-2.08-2.999-3c2.72-2.08,3.799-3.439,5.159-6.439L80.468,142.659z M77.508,140.259
                    c-1.159,0-1.959,0.04-2.759,0.12c0.08-1.04,0.12-1.84,0.12-3.679v-18.957c0-1.28-0.04-2.08-0.12-3.439
                    c0.84,0.12,1.68,0.16,3.159,0.16h6.559c1.24-0.04,2.28-0.08,3.12-0.16c-0.12,1.12-0.16,2-0.16,3.68v18.876
                    c0,1.6,0.04,2.56,0.12,3.52c-0.96-0.08-1.88-0.12-2.8-0.12H77.508z M78.588,121.823h5.039v-3.72h-5.039V121.823z
                     M78.588,129.062h5.039v-3.799h-5.039V129.062z M78.588,136.66h5.039v-4.159h-5.039V136.66z M84.707,140.739
                    c1.92,3.12,2.92,4.319,5.239,6.199c-1.12,0.76-1.68,1.32-3.12,2.879c-2.279-2.399-3.599-4.199-5.318-7.159L84.707,140.739z
                     M89.747,140.259c0.16-1,0.2-1.919,0.2-3.399v-17.517c0-1.52-0.04-2.399-0.2-3.399h4.399c-0.16,0.92-0.2,1.88-0.2,3.479v17.397
                    c0,1.6,0.04,2.56,0.16,3.439H89.747z M100.544,145.299c0,3.319-1.079,4.199-5.278,4.199c-0.84,0-2.6-0.04-3.399-0.08
                    c-0.28-2.04-0.44-2.72-1-4.239c1.56,0.24,2.64,0.32,4.079,0.32c1.359,0,1.6-0.16,1.6-1.08v-25.996c0-1.84-0.08-3.12-0.24-4.6
                    h4.479c-0.2,1.16-0.24,2.36-0.24,4.6V145.299z"
            />
            <path
              class="st5"
              d="M123.868,132.541c0,1.76,0,2.2,0.08,3.2c-0.399,0-1.72-0.04-3.919-0.08h-6.639
                    c-0.32,6.679-1.2,10.118-3.56,14.238c-1.2-1.48-2.08-2.24-3.56-3.16c2.479-4.239,3.159-8.318,3.159-19.117
                    c0-2.68-0.04-4.079-0.2-5.559c1.32,0.08,2.32,0.12,4.239,0.12h6.479c1.84,0,2.8-0.04,4.039-0.12c-0.08,0.84-0.12,2.04-0.12,3.6
                    V132.541z M107.71,114.784c1.16,0.16,2.24,0.2,4.319,0.2h8.639c2.359,0,3.319-0.04,4.359-0.2v4.479
                    c-1.04-0.16-2.08-0.2-4.159-0.2h-9.079c-1.839,0-2.959,0.04-4.079,0.2V114.784z M119.748,131.861v-5.919h-6.239v2.879
                    c0,1.52,0,1.88-0.04,3.04H119.748z M130.706,129.581c-0.239,4.879-0.76,8.039-1.76,10.918c-0.84,2.399-1.959,4.559-3.479,6.479
                    c-0.6,0.84-1.199,1.52-2.56,3c-1.079-1.48-1.919-2.32-3.319-3.32c3.08-2.879,4.68-5.399,5.68-8.838
                    c0.88-3.04,1.279-7.519,1.279-14.797c0-3.759-0.04-5-0.16-6.319c4.92-0.04,11.719-1.56,14.918-3.36l2.279,4.08
                    c-0.72,0.16-0.96,0.24-1.84,0.52c-4.119,1.28-6.719,1.839-10.918,2.439v4.999h9.079c1.879,0,2.719-0.04,3.879-0.24v4.639
                    c-1.08-0.16-2-0.2-3.52-0.2h-0.6v15.837c0,2.08,0.04,3.08,0.24,4.319h-4.72c0.16-1.28,0.24-2.399,0.24-4.359v-15.797H130.706z"
            />
          </g>
        </g>
        <g>
          <g>
            <rect
              x="35.111"
              y="12.955"
              class="st4"
              width="98.079"
              height="76.617"
            />
            <path
              class="st5"
              d="M133.191,92.572H35.112c-1.657,0-3-1.343-3-3V12.955c0-1.657,1.343-3,3-3h98.079c1.657,0,3,1.343,3,3
                    v76.617C136.191,91.229,134.848,92.572,133.191,92.572z M38.112,86.572h92.079V15.955H38.112V86.572z"
            />
          </g>
          <g>
            <path
              class="st5"
              d="M133.191,30.143H35.112c-1.657,0-3-1.343-3-3s1.343-3,3-3h98.079c1.657,0,3,1.343,3,3
                    S134.848,30.143,133.191,30.143z"
            />
          </g>
          <g>
            <rect
              x="89.91"
              y="44.169"
              class="st4"
              width="23.067"
              height="45.403"
            />
            <path
              class="st5"
              d="M112.977,92.572H89.91c-1.657,0-3-1.343-3-3V44.169c0-1.657,1.343-3,3-3h23.067c1.657,0,3,1.343,3,3v45.403
                    C115.977,91.229,114.634,92.572,112.977,92.572z M92.91,86.572h17.067V47.169H92.91V86.572z"
            />
          </g>
          <g>
            <rect
              x="52.53"
              y="4.247"
              class="st4"
              width="16.243"
              height="34.757"
            />
            <path
              class="st5"
              d="M68.773,42.004H52.53c-1.657,0-3-1.343-3-3V4.247c0-1.657,1.343-3,3-3h16.243c1.657,0,3,1.343,3,3v34.757
                    C71.773,40.661,70.43,42.004,68.773,42.004z M55.53,36.004h10.243V7.247H55.53V36.004z"
            />
          </g>
          <g>
            <rect
              x="84.476"
              y="44.169"
              class="st4"
              width="33.935"
              height="14.188"
            />
            <path
              class="st5"
              d="M118.411,61.358H84.476c-1.657,0-3-1.343-3-3V44.169c0-1.657,1.343-3,3-3h33.935c1.657,0,3,1.343,3,3
                    v14.188C121.411,60.014,120.068,61.358,118.411,61.358z M87.476,55.358h27.935v-8.188H87.476V55.358z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {};
</script>
<style lang="scss">
.st0 {
  display: none;
}
// .st1 {
//   display: inline;
//   fill: #d2ddf0;
// }
// .st2 {
//   display: inline;
//   fill: #1e58b5;
// }
.st3 {
  enable-background: new;
}
.st4 {
  fill: #ffffff;
}
.st5 {
  fill: #1e58b5;
}
// .st6 {
//   fill: none;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st7 {
//   fill: #ffffff;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st8 {
//   fill: #1e58b5;
//   stroke: #1e58b5;
//   stroke-width: 4;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st9 {
//   fill: none;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
</style>